// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — number-input.classic.js, новая — number-input.cp.js
import { isCp } from 'libs/design';
import * as classic from './number-input.classic';
import * as cp from './number-input.cp';

export const NumberInput = isCp ? cp.NumberInput : classic.NumberInput;
